export const STATE_PROP_PREFIX = 'state:';

export const STATE_PROP_FETCHED_AT = `${STATE_PROP_PREFIX}fetchedAt`;


// WEBPACK FOOTER //
// ./src/reducers/apiResources.const.js